import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSort } from "../../helpers/product";
import { limpiaPrincipioActivo } from "../../store/slices/bioequivalente-slice";


const ShopCategories = ({ categories, getSortParams }) => {

  const dispatch = useDispatch();
  //console.log("CATEGORIAS");
  //console.log(categories[0]);
  //console.log(categories[1]);
  //console.log(categories[2]);
  //console.log(categories[3]);
  //console.log(categories[4]);
  return (
    <div className="sidebar-widget d-lg-block d-xl-block d-md-block d-sm-block d-xs-none d-none">
      {/* className={"d-lg-block d-xl-block d-md-block d-sm-block d-xs-none d-none"} */}
      <h4 className="pro-sidebar-title">Filtro por principio activo </h4>
      <div className="sidebar-widget-list mt-30">
        {categories ? (
          <ul>
            <li>
              <div className="sidebar-widget-list-left">
                <button
                  onClick={e => {
                    getSortParams("category", "");
                    setActiveSort(e);
                    dispatch(limpiaPrincipioActivo());
                  }}
                >
                  <span className="checkmark" /> Todos
                </button>
              </div>
            </li>
            {categories.map((category, key) => {
              return (
                <li key={key}>
                  <div className="sidebar-widget-list-left">
                    <button
                      onClick={e => {
                        getSortParams("category", category);
                        setActiveSort(e);
                      }}
                    >
                      {" "}
                      <span className="checkmark" /> {category.toLowerCase()}{" "}
                    </button>
                  </div>
                </li>
              );
            })}
            
          </ul>
        ) : (
          "Sin datos, intente mas tarde."
        )}
      </div>
    </div>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  getSortParams: PropTypes.func
};

export default ShopCategories;
